

export class Camera {
    name: string;
    ip: string;
    externalId: string;
    battery: number;
    port: number;
    location: string | latlngConvert;
    syncTime: number;
    lastSync: LastSync;
    application: Application;
    client: Client;
    lastLogon: CameraLogon;
    id: string;
}


export class CameraLogon {

    date: Date;

}

export class Client {

    name: string;
}

export class LastSync {
    status: string;
    startedOn: string;
    completedOn: string;
    id: string;
}
export class Application {
    ApplicationName: string;
    id: string;

}

export class CameraPost {
    id?: string;
    name: string;
    ip: string;
    port: number;
    syncTime?: number;

}

export class ConfigCamera {
    mode: string;
    reset: boolean;
}

export class latlngConvert {
    lng: number;
    lat: number;


    constructor(lat: number, lng: number) {
        this.lng = lng;
        this.lat = lat;

    }

}